import { render, staticRenderFns } from "./codetest.vue?vue&type=template&id=56a0b5f8&"
import script from "./codetest.vue?vue&type=script&lang=js&"
export * from "./codetest.vue?vue&type=script&lang=js&"
import style0 from "./codetest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports